import React, { useState, useEffect, useRef } from 'react';
import styles from './style.module.scss';
import { FaUserCircle, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { BiSolidQuoteRight } from "react-icons/bi";



const DepoimentosHome = ({ depoimentos }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoplay, setAutoplay] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const intervalRef = useRef(null);
  const carouselRef = useRef(null);

  const totalSlides = depoimentos?.length || 0;

  // Auto-play functionality
  useEffect(() => {
    if (autoplay && totalSlides > 1) {
      intervalRef.current = setInterval(() => {
        nextSlide();
      }, 4000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [autoplay, currentSlide, totalSlides]);

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
    setTimeout(() => setIsTransitioning(false), 300);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    setTimeout(() => setIsTransitioning(false), 300);
  };

  const goToSlide = (index) => {
    if (isTransitioning || index === currentSlide) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    setTimeout(() => setIsTransitioning(false), 300);
  };

  const handleMouseEnter = () => {
    setAutoplay(false);
  };

  const handleMouseLeave = () => {
    setAutoplay(true);
  };

  // Touch handlers for mobile swipe
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setAutoplay(false);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && totalSlides > 1) {
      nextSlide();
    }
    if (isRightSwipe && totalSlides > 1) {
      prevSlide();
    }

    setAutoplay(true);
  };

  if (!depoimentos || depoimentos.length === 0) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='2' viewBox='0 0 20 2' fill='none'>
              <path d='M0 1H20' stroke='#9F9FA2' />
            </svg>
            Clientes realizados
          </h1>
          <h3>Quem compra recomenda</h3>
        </div>
        <div className={styles.noDepoimentos}>
          <p>Nenhum depoimento disponível no momento.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>
          <svg xmlns='http://www.w3.org/2000/svg' width='20' height='2' viewBox='0 0 20 2' fill='none'>
            <path d='M0 1H20' stroke='#9F9FA2' />
          </svg>
          Clientes realizados
        </h1>
        <h3>Quem compra recomenda</h3>
      </div>

      <div 
        className={styles.carouselWrapper}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Navigation Buttons - Desktop Only */}
        {totalSlides > 1 && (
          <>
            <button 
              className={`${styles.navButton} ${styles.prevButton}`}
              onClick={prevSlide}
              disabled={isTransitioning}
              aria-label="Depoimento anterior"
            >
              <FaChevronLeft />
            </button>
            <button 
              className={`${styles.navButton} ${styles.nextButton}`}
              onClick={nextSlide}
              disabled={isTransitioning}
              aria-label="Próximo depoimento"
            >
              <FaChevronRight />
            </button>
          </>
        )}

        {/* Carousel Container */}
        <div className={styles.carouselContainer} ref={carouselRef}>
          <div 
            className={styles.carouselTrack}
            style={{
              transform: `translateX(-${currentSlide * 100}%)`,
              transition: isTransitioning ? 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)' : 'none'
            }}
          >
            {depoimentos.map((depoimento, index) => (
              <div 
                key={depoimento.id} 
                className={`${styles.depoimentoCard} ${
                  index % 2 === 0 ? styles.evenSlide : styles.oddSlide
                }`}
              >
                <div className={styles.cardContent}>
                  <div className={styles.quoteIcon}>
                    <BiSolidQuoteRight />
                  </div>
                  
                  <div className={styles.testimonialContent}>
                    <h1 className={styles.testimonialTitle}>
                      {depoimento.depoimento.slice(0, 20)}...
                    </h1>
                    <h2 className={styles.testimonialText}>
                      "{depoimento.depoimento}"
                    </h2>
                  </div>

                  <div className={styles.containerUsuarioDepoimento}>
                    <div className={styles.userAvatar}>
                      <FaUserCircle />
                    </div>
                    <div className={styles.userInfo}>
                      <h3 className={styles.userName}>{depoimento.nome}</h3>
                      <p className={styles.userLabel}>Cliente verificado</p>
                    </div>
                  </div>
                </div>

                {/* Decorative elements */}
                <div className={styles.cardDecoration}>
                  <div className={styles.decorativeCircle}></div>
                  <div className={styles.decorativeCircle}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dots Indicator */}
        {totalSlides > 1 && (
          <div className={styles.dotsContainer}>
            {depoimentos.map((_, index) => (
              <button
                key={index}
                className={`${styles.dot} ${index === currentSlide ? styles.activeDot : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Ir para depoimento ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Progress Bar */}
        {autoplay && totalSlides > 1 && (
          <div className={styles.progressBar}>
            <div 
              className={styles.progressFill}
              style={{
                animationDuration: '4s',
                animationPlayState: autoplay ? 'running' : 'paused'
              }}
            />
          </div>
        )}

        {/* Swipe Indicator for Mobile */}
        <div className={styles.swipeIndicator}>
          <span>← Deslize para ver mais →</span>
        </div>
      </div>
    </div>
  );
};

export default DepoimentosHome;
